import { memo, useState } from 'react';
import { Text, InputField } from '../../components';
import "./GetInTouchForm.scss";

function MemoComponent({ id }: { id: string }) {
  const [email, setEmail] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  return (
    <section id={id} className="get-in-touch-form">
      <div className="section-content">
        <Text variant="title2" weight={700}>Let's Get in Touch</Text>

        <div className="form-container">
          <Text variant="content2" weight={700} className="mb-5">email</Text>
          <InputField value={email} placeholder="example@email.com" onChange={setEmail} className="mb-20"/>

          <Text variant="content2" weight={700} className="mb-5">name</Text>
          <InputField value={name} placeholder="full name" onChange={setName} className="mb-20"/>

          <Text variant="content2" weight={700} className="mb-5">message</Text>
          <InputField
            value={message}
            placeholder="write your message..."
            onChange={setMessage}
            className="mb-20"
            component='textarea'
          />
        </div>
      </div>
    </section>
  )
}

export const GetInTouchForm = memo(MemoComponent);